export default {
  page_title: 'Search Tips',
  t_operators: 'Operators List',
  t_precedence: 'Precedence',
  operators: [
    'Search operators are special commands you can type for more specific query results. They are currently usable in the search bar found in the header and frontpage of the site.',
    'For seaches containing more than one operator, the query will be processed in the following sequence:'
  ],
}